// extracted by mini-css-extract-plugin
export default {"Questionnaire":"styles_Questionnaire__FaBQf"};